/* eslint-disable vue/multi-word-component-names */
/*
 *  TTTech nerve-ui-components
 *  Copyright(c) 2021. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

// Import vue component
import VmVideoOptions from './components/VmVideoOptions.vue';
import VmResources from './components/VmResources.vue';
import WorkloadControl from './components/WorkloadControl.vue';
import WorkloadControlCompose from './components/WorkloadControlCompose.vue';
import TheNerveTable from './components/TheNerveTable.vue';
import TableActionMenu from './components/helpers/TableActionMenu.vue';
import DatabaseTable from './components/DatabaseTable.vue';
import NetworkProperties from './components/NetworkProperties.vue';
import VmSnapshot from './components/VmSnapshot.vue';
import VmBackups from './components/VmBackups.vue';
import Login from './components/Login.vue';
import ProgressLinearWithStatus from './components/ProgressLinearWithStatus.vue';
import NerveSimpleTable from './components/NerveSimpleTable.vue';
import NerveButton from './components/NerveButton.vue';
import NerveDialog from './components/NerveDialog.vue';
import ComposeServiceNameRc from './components/helpers/ComposeServiceNameRc.vue';

// Declare install function executed by Vue.use()
export function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('VmVideoOptions', VmVideoOptions);
  Vue.component('VmResources', VmResources);
  Vue.component('WorkloadControl', WorkloadControl);
  Vue.component('WorkloadControlCompose', WorkloadControlCompose);
  Vue.component('TheNerveTable', TheNerveTable);
  Vue.component('TableActionMenu', TableActionMenu);
  Vue.component('DatabaseTable', DatabaseTable);
  Vue.component('NetworkProperties', NetworkProperties);
  Vue.component('VmSnapshot', VmSnapshot);
  Vue.component('VmBackups', VmBackups);
  Vue.component('Login', Login);
  Vue.component('ProgressLinearWithStatus', ProgressLinearWithStatus);
  Vue.component('NerveSimpleTable', NerveSimpleTable);
  Vue.component('NerveButton', NerveButton);
  Vue.component('NerveDialog', NerveDialog);
  Vue.component('ComposeServiceNameRc', ComposeServiceNameRc);
}

// Create module definition for Vue.use()
const plugin = {
  install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
export {
  VmVideoOptions,
  VmResources,
  WorkloadControl,
  WorkloadControlCompose,
  TheNerveTable,
  DatabaseTable,
  TableActionMenu,
  NetworkProperties,
  VmSnapshot,
  VmBackups,
  Login,
  ProgressLinearWithStatus,
  NerveSimpleTable,
  NerveButton,
  NerveDialog,
  ComposeServiceNameRc,
};
